<template>
    <div>
        <h1>Opleidingen</h1>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Opleiding</th>
                        <th>Instituut</th>
                        <th>Jaar</th>
                        <th>Voltooid</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="edu in educations" :key="edu.id">
                        <td>{{edu.name}}</td>
                        <td>{{edu.institute}}</td>
                        <td>{{edu.year}}</td>
                        <td>
                            <span v-if="edu.completed">JA</span>
                            <span v-else>NEE</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <h1>Certificeringen</h1>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Opleiding</th>
                        <th>Instituut</th>
                        <th>Jaar</th>
                        <th>Voltooid</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="edu in certifications" :key="edu.id">
                        <td>{{edu.name}}</td>
                        <td>{{edu.institute}}</td>
                        <td>{{edu.year}}</td>
                        <td>
                            <span v-if="edu.completed">JA</span>
                            <span v-else>NEE</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProfessionalProfileEducations',
    props: ['user'],
    data() {
        return {
            //educations: [{id: 0, svpb: 'test education 1', institute: 'test intitute', year: '2019', completed: true}, {id: 0, svpb: 'test education 2', institute: 'test intitute', year: '2019', completed: true}],
            //certifications: [{id: 0, svpb: 'test certification', institute: 'test intitute', year: '2019', completed: true}]
        }
    },
    methods: 
    {

    },
    computed: {
        profile() {
            if(this.user)
                return this.user.professionalProfile;
            return {};
        },
        educations() {
            return this.profile.educations;
        },
        certifications() {
            return this.profile.certifications;
        }
    }
}
</script>

<style scoped>
</style>

